import Cell from './Cell';
import Row from './Row';
import Table from './Table';
import Caption from './Caption';
const SummaryTable = {
    Cell,
    Row,
    Table,
    Caption,
};
export default SummaryTable;
